module.exports = __webpack_public_path__ + "img/X_logo_2023_original.457ee2e6.svg";